import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "antd";

const EbookTimeModal = ({ open, onOk, onCancel }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [nextLocation, setNextLocation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const skipBlockRef = useRef(false);

  const handleConfirm = () => {
    setShowModal(false);
    setConfirmedNavigation(true);
    skipBlockRef.current = true; //
    if (nextLocation) {
      navigate(nextLocation);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setNextLocation(null);
  };

  return (
    <Modal
                open={open}
                title="Are you sure?"
                onOk={onOk}
                onCancel={onCancel}
                okText="Yes"
                cancelText="Cancel"
                closable={false}
                maskClosable={false}
                keyboard={false}
                styles={{ mask:{backdropFilter: 'blur(5px)'}}}
                mask={true}
            >
                Timer-based assignments can't be "finished later", it will be submitted automatically.
            </Modal> 
  );
};

export default EbookTimeModal;